import axios from "axios";

export const listCabinetsQuery = async (committeeId) =>
  await axios.post("/api/v1.0/cabinet/listCabinets", { committeeId });
